/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Swal from 'sweetalert2';
import { IoIosShareAlt } from 'react-icons/io';

import { format, parseISO } from 'date-fns';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { BsChatRightText } from 'react-icons/bs';

import { Container } from './styles';
import Input from '~/components/Input';
import InputDate from '~/components/InputDate';
import InputMask from '~/components/InputMask';
import InputCheckbox, {
  IOption as IOptionCheckbox,
} from '~/components/InputCheckbox';

import Modalities, { IModalitiesHandle, IModalityData } from './Modalities';
import Categories, { ICategoriesHandle } from './Categories';
import Batches, { IBatch, IBatchesHandle } from './Batches';
import PricesPlaces, { IPricesPlacesHandle } from './PricesPlaces';
import BasicData, {
  IBasicDataHandle,
  IInitialData as IBasicData,
} from './BasicData';
import api from '~/services/api';
import Toast from '~/utils/toast';
import Loading from '~/components/Loading';
import Select, { IOption } from '~/components/Select';
import { formatPrice } from '~/utils/format';
import { KrEdit, KrTrash } from '~/components/KoroIcons';
import Sponsors, { ICard, ISponsorsHandle } from './Sponsors';
import ImageGallery, { IFile, IImageGalleryHandle } from './ImageGallery';
import Kits, { ICardKit, IKitsHandle } from './Kits';
import Financial, {
  IFinancialHandle,
  IPaymentMethod,
  IEventPaymentMethod,
  ITarget,
} from './Financial';
import {
  IBatchCategories,
  IBatchCategory,
  IBatchResponse,
  IEvent,
} from './Interfaces';
import { IQuestion } from '../Questions';
import formatDate from '~/utils/formatDate';

interface IParams {
  slug: string;
}

interface ISize {
  id: number;
  size: string;
  quantity?: string;
  qtdSold?: number;
  active: boolean;
}

interface IContract {
  id: number;
  code: string;
  fantasy_name: string;
  tax_type: string;
  tax: string;
  service_type: string;
  service: string;
}

export function generateArrays(
  data: IBatchCategories[],
  batchesData: IBatchResponse[]
): { modalities: IModalityData[]; batches: IBatch[] } {
  // ---- 1️⃣ Gerar o array de modalidades ----
  const modalityMap = new Map<number, IModalityData>();

  data.forEach((item) => {
    if (!modalityMap.has(item.modality?.id)) {
      modalityMap.set(item.modality?.id, {
        input_id: item.id,
        id: item.modality?.id,
        name: item.modality?.name,
        order: item.modality?.order,
        categories: [],
      });
    }

    const modality = modalityMap.get(item.modality?.id);
    if (modality) {
      if (modality.categories && modality.categories.length > 0) {
        if (!modality.categories.some((c) => c.id === item.category?.id)) {
          if (item.category) {
            modality.categories.push({
              input_id: item.id,
              id: item.category?.id,
              name: item.category?.name,
              order: item.category?.order,
              elderly: item.category?.is_elderly,
              child: item.category?.is_child,
              male: item.category?.is_male,
              female: item.category?.is_female,
              qty_min: item.category?.min_quantity,
              has_kit: item.category?.has_kit,
              has_age_group: item.category?.has_age_group,
              min_age: item.category?.min_age,
              max_age: item.category?.max_age,
            });
          }
        }
      } else if (modality.categories && item.category) {
        modality.categories.push({
          input_id: item.id,
          id: item.category?.id,
          name: item.category?.name,
          order: item.category?.order,
          elderly: item.category?.is_elderly,
          child: item.category?.is_child,
          male: item.category?.is_male,
          female: item.category?.is_female,
          qty_min: item.category?.min_quantity,
          has_kit: item.category?.has_kit,
          has_age_group: item.category?.has_age_group,
          min_age: item.category?.min_age,
          max_age: item.category?.max_age,
        });
      }
    }
  });

  const modalitiesData: IModalityData[] = Array.from(modalityMap.values()).sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0)
  );

  modalitiesData.forEach((modality) => {
    if (modality.categories) {
      modality.categories.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
  });

  // ---- 2️⃣ Gerar o array de batches ----
  const batchMap = new Map<number, IBatch>();

  const ensureBatch = (
    batchId: number,
    quantity: number,
    dueDate: string,
    quantitySold: number
  ) => {
    if (!batchMap.has(batchId)) {
      batchMap.set(batchId, {
        input_id: batchId,
        qtdPlaces: quantity,
        expiration: new Date(dueDate),
        restPlaces: quantity - quantitySold,
        qtdSold: quantitySold,
        batchesCategories: [],
      });
    }
  };

  // 2.1 Montar batches a partir do array de batches (se existir)
  if (batchesData && batchesData.length > 0) {
    batchesData.forEach((batch) => {
      ensureBatch(
        batch.id,
        batch.quantity,
        batch.due_date,
        batch.quantity_sold
      );
    });
  }

  // 2.2 Garantir batches a partir de batchesCategories (fallback)
  data.forEach((item) => {
    if (item.batch) {
      ensureBatch(
        item.batch_id,
        item.batch.quantity,
        item.batch.due_date,
        item.batch.quantity_sold
      );
    }
  });

  // 2.3 Preencher batchesCategories sem duplicação
  data.forEach((item) => {
    const batchData = batchMap.get(item.batch_id);
    if (!batchData) {
      return;
    }

    const alreadyExists = batchData.batchesCategories?.some(
      (batchCategory) => batchCategory.id === item.id
    );

    if (!alreadyExists) {
      batchData.batchesCategories!.push({
        id: item.id,
        batch_id: item.batch_id,
        category_id: item.category_id,
        modality_id: item.modality_id,
        event_id: item.event_id,
        quantity: item.quantity,
        price: item.price,
        on: item.on,
        quantity_sold: item.quantity_sold,
      });
    }
  });

  const newBatchesData: IBatch[] = Array.from(batchMap.values());

  return { modalities: modalitiesData, batches: newBatchesData };
}

const ManageEvent: React.FC = () => {
  const params = useParams<IParams>();
  const history = useHistory();
  const location = useLocation();

  const basicDataFormRef = useRef<IBasicDataHandle>(null);
  const galleryFormRef = useRef<IImageGalleryHandle>(null);
  const sponsorsFormRef = useRef<ISponsorsHandle>(null);
  const kitsFormRef = useRef<IKitsHandle>(null);
  const modalitiesFormRef = useRef<IModalitiesHandle>(null);
  const categoriesFormRef = useRef<ICategoriesHandle>(null);
  const batchesFormRef = useRef<IBatchesHandle>(null);
  const pricesPlacesFormRef = useRef<IPricesPlacesHandle>(null);
  const financeFormRef = useRef<IFinancialHandle>(null);
  const formRef = useRef<FormHandles>(null);

  const [progressNumber, setProgressNumber] = useState(1);
  const [name, setName] = useState('');
  const [typeSelected, setTypeSelected] = useState<number | undefined>(
    undefined
  );
  const [typeName, setTypeName] = useState('');
  const [statusName, setStatusName] = useState('Cadastrando');
  const [btnPhotoProd, setBtnPhotoProd] = useState('galery');
  const [basicData, setBasicData] = useState({} as IBasicData);
  const [cardsSponsors, setCardsSponsors] = useState<ICard[]>([]);
  const [filesInfo, setFilesInfo] = useState<IFile[]>([]);
  const [batches, setBatches] = useState<IBatch[]>([]);
  const [modalities, setModalities] = useState<IModalityData[]>([]);
  const [loading, setLoading] = useState(false);
  const [creditPayment, setCreditPayment] = useState(false);
  const [contractsOptions, setContractsOptions] = useState<IOption[]>([]);
  const [contractSelected, setContractSelected] = useState({} as IContract);
  const [paymentsMethods, setPaymentsMethods] = useState<IPaymentMethod[]>([]);
  const [eventPaymentsMethods, setEventPaymentsMethods] = useState<
    IEventPaymentMethod[]
  >([]);
  const [paymentMethodsOptions, setPaymentMethodsOptions] = useState<
    IOptionCheckbox[]
  >([]);
  const [batchesCategories, setBatchesCategories] = useState<IBatchCategory[]>(
    []
  );

  const [maxInstallments, setMaxInstallments] = useState(0);
  const [targets, setTargets] = useState({
    registration: 0,
    revenue: 0,
    avarageTicket: 0,
  });
  const [beforePayment, setBeforePayment] = useState(0);
  const [cardsKit, setCardsKit] = useState<ICardKit[]>([]);

  const [sizesKit, setSizesKit] = useState<ISize[]>([
    { id: 1, size: 'PP', quantity: '0', qtdSold: 0, active: false },
    { id: 2, size: 'P', quantity: '0', qtdSold: 0, active: false },
    { id: 3, size: 'M', quantity: '0', qtdSold: 0, active: false },
    { id: 4, size: 'G', quantity: '0', qtdSold: 0, active: false },
    { id: 5, size: 'GG', quantity: '0', qtdSold: 0, active: false },
    { id: 6, size: 'XG', quantity: '0', qtdSold: 0, active: false },
    { id: 7, size: 'XXG', quantity: '0', qtdSold: 0, active: false },
    { id: 8, size: 'PP_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 9, size: 'P_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 10, size: 'M_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 11, size: 'G_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 12, size: 'GG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 13, size: 'XG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 14, size: 'XXG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 15, size: '2', quantity: '0', qtdSold: 0, active: false },
    { id: 16, size: '4', quantity: '0', qtdSold: 0, active: false },
    { id: 17, size: '6', quantity: '0', qtdSold: 0, active: false },
    { id: 18, size: '8', quantity: '0', qtdSold: 0, active: false },
    { id: 19, size: '10', quantity: '0', qtdSold: 0, active: false },
    { id: 20, size: '12', quantity: '0', qtdSold: 0, active: false },
    { id: 21, size: '14', quantity: '0', qtdSold: 0, active: false },
  ]);
  const [kitId, setKitId] = useState<number | undefined>(undefined);
  const [kitDescription, setKitDescription] = useState('');
  const [kitStockControl, setKitStockControl] = useState(true);
  const [kitVariationSize, setKitVariationSize] = useState(false);
  const [kitEnabled, setKitEnabled] = useState(true);
  const [someSellout, setSomeSellout] = useState(false);
  const [errorKits, setErrorKits] = useState(false);

  // subir

  const pageType = useMemo(() => {
    if (
      location.pathname.includes('resumo') ||
      statusName === 'Em Alteração' ||
      statusName === 'Rascunho'
    ) {
      setProgressNumber(10);
      return 'summary';
    }

    if (location.pathname.includes('editar-evento')) {
      return 'update';
    }

    return 'new';
  }, [location.pathname, statusName]);

  useEffect(() => {
    if (params.slug) {
      setLoading(true);
      api.get('apagar-cache').then(() => {
        api
          .get<IEvent>(`events/${params.slug}`)
          .then((response) => {
            const questionsData = response.data.questions.map<IQuestion>(
              (question) => {
                let type = 'free-text';

                if (question.question_type_id === 2) {
                  type = 'unique-choice';
                }

                if (question.question_type_id === 3) {
                  type = 'multiple-choice';
                }

                const alternatives = question.alternatives.map(
                  (alternative) => ({
                    id: alternative.id,
                    text: alternative.name,
                    new: false,
                  })
                );

                return {
                  id: question.id,
                  question: question.name,
                  type: type as IQuestion['type'],
                  order: question.order,
                  alternatives: type !== 'free-text' ? alternatives : undefined,
                  isRequired: question.required ?? true,
                  suspended: question.suspended ?? false,
                };
              }
            );

            const sponsorsEvents = response.data.sponsorsEvents.map<ICard>(
              (sponsorEvent) => ({
                id: sponsorEvent.id,
                sponsor_id: sponsorEvent.sponsor.id,
                name: sponsorEvent.sponsor.name,
                description: sponsorEvent.description,
                link: sponsorEvent.link,
                file: {
                  id: sponsorEvent.archive.id,
                  name: sponsorEvent.archive.name,
                  url: sponsorEvent.archive.archive_url,
                  isNew: false,
                },
                isNew: false,
              })
            );

            setCardsSponsors(sponsorsEvents);
            setBasicData({
              event_id: response.data.id,
              address_id: response.data.address.id,
              contract_id: response.data.contract_id,
              name: response.data.name,
              description: response.data.description,
              type: response.data.type.id.toString(),
              date: parseISO(formatDate(response.data.date, 'yyyy-MM-dd')),
              end_date: parseISO(
                formatDate(
                  response.data.end_date || response.data.date,
                  'yyyy-MM-dd'
                )
              ),

              hour:
                response.data.hour && response.data.hour === '00:00:00'
                  ? ''
                  : response.data.hour,

              end_hour:
                response.data.end_hour && response.data.end_hour === '00:00:00'
                  ? ''
                  : response.data.end_hour,
              sales_end_date: parseISO(
                formatDate(
                  response.data.sales_end_date || response.data.date,
                  'yyyy-MM-dd'
                )
              ),
              status: response.data.status_id,
              address:
                response.data.address.full_address ||
                `${response.data.address.street} n˚ ${response.data.address.number}, ${response.data.address.neighborhood} - ${response.data.address.city}/${response.data.address.state}, CEP: ${response.data.address.zip_code}`,
              street: response.data.address.street,
              number: response.data.address.number,
              city: response.data.address.city,
              neighborhood: response.data.address.neighborhood,
              state: response.data.address.state,
              zipCode: response.data.address.zip_code,
              country: response.data.address.country,
              full_address: response.data.address.full_address,
              fill_before: response.data.fill_before,
              questions: questionsData,
              target_registration: response.data.target_registration,
              target_revenue: parseFloat(response.data.target_revenue),
              target_avarage_ticket: response.data.target_avarage_ticket
                ? parseFloat(response.data.target_avarage_ticket)
                : 0,
              unique_ticket: response.data.unique_ticket,
            });
            setTypeSelected(response.data.type.id);
            setTypeName(response.data.type.name);
            setStatusName(
              response.data.status ? response.data.status.name : 'Cadastrando'
            );
            setBeforePayment(Number(response.data.fill_before));
            setName(response.data.name);
            setMaxInstallments(
              response.data.paymentsMethods.find(
                (paymentMethod) => !!paymentMethod.installments
              )?.installments || 0
            );
            setEventPaymentsMethods(response.data.paymentsMethods);

            setTargets({
              registration: response.data.target_registration,
              revenue: response.data.target_revenue
                ? parseFloat(response.data.target_revenue)
                : 0,
              avarageTicket: response.data.target_avarage_ticket
                ? parseFloat(response.data.target_avarage_ticket)
                : 0,
            });

            setKitEnabled(response.data.kit_enabled ?? true);

            if (response.data.kit2) {
              setKitId(response.data.kit2.id);
              setKitDescription(response.data.kit2.description);
              setKitStockControl(response.data.kit2.stock_control);
              setKitVariationSize(response.data.kit2.has_size_variation);
              setSizesKit((oldState) =>
                oldState.map((size) => {
                  const sizeSelected = response.data.kit2.quantities.find(
                    (quantity) => quantity.size === size.size
                  );
                  if (sizeSelected) {
                    return {
                      ...size,
                      id: sizeSelected.kit2Size?.id,
                      quantity_id: sizeSelected.id,
                      quantity: sizeSelected.quantity_expected.toString(),
                      qtdSold: sizeSelected.quantity_used,
                      active: sizeSelected.on,
                    };
                  }

                  return size;
                })
              );

              const cards = response.data.kit2.images.map((image) => ({
                id: image.id,
                description: image.description,
                link: image.link,
                file: {
                  id: image.archive.id,
                  url: image.archive.archive_url,
                  name: image.archive.name,
                },
              }));

              setCardsKit(cards);
            }

            const files = response.data.archivesEvents.map<IFile>(
              (archiveEvent) => ({
                id: archiveEvent.archive.id,
                archiveEvent_id: archiveEvent.id,
                name: archiveEvent.archive.name,
                url: archiveEvent.archive.archive_url,
              })
            );

            const { modalities: modalitiesData, batches: batchesData } =
              generateArrays(
                response.data.batchesCategories,
                response.data.batches
              );

            const batchesCategoriesData =
              response.data.batchesCategories.map<IBatchCategory>(
                (batchCategory) => ({
                  id: batchCategory.id,
                  batch_id: batchCategory.batch_id,
                  category_id: batchCategory.category_id,
                  modality_id: batchCategory.modality_id,
                  event_id: batchCategory.event_id,
                  price: batchCategory.price,
                  quantity: batchCategory.quantity,
                  quantity_sold: batchCategory.quantity_sold,
                  on: batchCategory.on,
                })
              );

            const sellout = response.data.batchesCategories.some(
              (batchCategory) => batchCategory.quantity_sold
            );
            setSomeSellout(sellout);

            setBatchesCategories(batchesCategoriesData);
            setFilesInfo(files);
            setBatches(batchesData);
            setModalities(modalitiesData);
          })
          .finally(() => {
            setLoading(false);
          });
      });
    }
  }, [params.slug]);

  useEffect(() => {
    api
      .get<IContract[]>('contracts/organizers', {
        params: { status: 'Ativo' },
      })
      .then((response) => {
        const data = response.data.map((contract) => ({
          id: contract.id,
          value: `#${contract.code} - ${contract.fantasy_name}`,
          selected: basicData.contract_id === contract.id,
        }));

        const selectedContractData = response.data.find(
          (contract) => contract.id === basicData.contract_id
        );

        if (selectedContractData) {
          setContractSelected(selectedContractData);
        } else if (response.data[0]) {
          setContractSelected(response.data[0]);
        }
        setContractsOptions(data);
      });
  }, [basicData.contract_id]);

  const progress = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const textProgress = [
    { name: 'Dados' },
    { name: 'Galeria' },
    { name: 'Patrocinadores' },
    { name: 'Kits' },
    { name: 'Modalidades' },
    { name: 'Categorias' },
    { name: 'Lotes' },
    { name: 'Preços' },
    { name: 'Financeiro' },
    { name: 'Resumo' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [progressNumber]);

  const handleChangeName = useCallback((value) => {
    setName(value);
  }, []);

  const handleChangeType = useCallback((option) => {
    setTypeName(option.value);
    setTypeSelected(option.id);
  }, []);

  const handleChangeBasicData = useCallback((data) => {
    setBasicData((oldState) => ({
      ...oldState,
      ...data,
    }));
    setProgressNumber(2);
  }, []);

  const addressMap = useMemo(() => {
    return basicData.address || 'Brazil';
  }, [basicData]);

  const handleChangeGallery = useCallback(async (data) => {
    setFilesInfo(data);
    setProgressNumber(3);
  }, []);

  const handleChangeSponsors = useCallback((sponsors) => {
    setCardsSponsors(sponsors);
    setProgressNumber(4);
  }, []);

  const handleChangeKits = useCallback(
    (
      kits,
      sizes,
      description,
      stockControl,
      hasSizeVariation,
      hasKitEnabled
    ) => {
      setCardsKit(kits);
      setSizesKit(sizes);
      setKitDescription(description);
      setKitStockControl(stockControl);
      setKitVariationSize(hasSizeVariation);
      setKitEnabled(hasKitEnabled);
      setProgressNumber(5);
    },
    []
  );

  const handleChangeModalities = useCallback(
    (modalitiesData, batchesCategoriesData, batchesData?: IBatch[]) => {
      setModalities(modalitiesData);
      setBatchesCategories(batchesCategoriesData);
      if (batchesData) {
        setBatches(batchesData);
      }
      setProgressNumber(6);
    },
    []
  );

  const handleChangeCategories = useCallback(
    (modalitiesData, batchesCategoriesData, batchesData?: IBatch[]) => {
      setModalities(modalitiesData);
      setBatchesCategories(batchesCategoriesData);
      if (batchesData) {
        setBatches(batchesData);
      }
      setProgressNumber(7);
    },
    []
  );

  const handleChangeBatches = useCallback(
    (batchesData, newBasicData, batchesCategoriesData) => {
      setBatches(batchesData);
      setBasicData(newBasicData);
      setBatchesCategories(batchesCategoriesData);
      setProgressNumber(8);
    },
    []
  );

  const handleChangePricesPlaces = useCallback(
    (batchesData, batchesCategoriesData) => {
      setBatches(batchesData);
      setBatchesCategories(batchesCategoriesData);
      setProgressNumber(9);
    },
    []
  );

  const handleChangeFinancial = useCallback(
    (
      eventPaymentsMethodsData: IEventPaymentMethod[],
      newBasicData: IBasicData,
      batchesData: IBatch[],
      targetsData: ITarget
    ) => {
      const maxInstallmentsData = eventPaymentsMethodsData.reduce(
        (acc, eventPaymentMethod) => {
          return acc + (eventPaymentMethod.installments || 0);
        },
        0
      );

      const avarageTicket = targetsData.revenue / targetsData.registration;
      setTargets((oldStats) => ({
        ...oldStats,
        avarageTicket: Number.isNaN(avarageTicket) ? 0 : avarageTicket,
        registration: targetsData.registration,
        revenue: Number.isNaN(targetsData.revenue) ? 0 : targetsData.revenue,
      }));

      setBatches(batchesData);
      setEventPaymentsMethods(eventPaymentsMethodsData);
      setPaymentsMethods((oldState) => {
        return oldState.map((payment) => {
          return {
            ...payment,
            active: eventPaymentsMethodsData.some(
              (eventPaymentMethod) =>
                eventPaymentMethod.payment_method_id === payment.id
            ),
          };
        });
      });
      setBasicData(newBasicData);
      setMaxInstallments(maxInstallmentsData);
      setBeforePayment(newBasicData.fill_before as number);
      setProgressNumber(10);
    },
    []
  );

  const handleClickNext = useCallback((currentProgress) => {
    switch (currentProgress) {
      case 1:
        basicDataFormRef.current?.submit();
        break;
      case 2:
        galleryFormRef.current?.submit();
        break;
      case 3:
        sponsorsFormRef.current?.submit();
        break;
      case 4:
        kitsFormRef.current?.submit();
        break;
      case 5:
        modalitiesFormRef.current?.submit();
        break;
      case 6:
        categoriesFormRef.current?.submit();
        break;
      case 7:
        batchesFormRef.current?.submit();
        break;
      case 8:
        pricesPlacesFormRef.current?.submit();
        break;
      case 9:
        financeFormRef.current?.submit();
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    api.get<IPaymentMethod[]>('payments-methods').then((response) => {
      setPaymentsMethods(response.data);
    });
  }, []);

  useEffect(() => {
    setCreditPayment(false);
    setPaymentMethodsOptions(
      paymentsMethods.map<IOptionCheckbox>((paymentMethod) => {
        let selected = true;

        if (paymentMethod.name === 'Gratuito') {
          selected = eventPaymentsMethods.some(
            (eventPaymentMethod) => eventPaymentMethod.payment_method_id === 0
          );
        }
        if (paymentMethod.name === 'Pix') {
          selected = eventPaymentsMethods.some(
            (eventPaymentMethod) => eventPaymentMethod.payment_method_id === 1
          );
        }
        if (paymentMethod.name === 'Boleto') {
          selected = eventPaymentsMethods.some(
            (eventPaymentMethod) => eventPaymentMethod.payment_method_id === 2
          );
        }
        if (paymentMethod.name === 'Débito') {
          selected = eventPaymentsMethods.some(
            (eventPaymentMethod) => eventPaymentMethod.payment_method_id === 3
          );
        }
        if (paymentMethod.name === 'Crédito') {
          selected = eventPaymentsMethods.some(
            (eventPaymentMethod) => eventPaymentMethod.payment_method_id === 4
          );
          if (selected) {
            setCreditPayment(true);
          }
        }
        return {
          label: paymentMethod.name,
          value: paymentMethod.id,
          selected,
        };
      })
    );
  }, [eventPaymentsMethods, paymentsMethods]);

  const handleSubmit = useCallback(async () => {
    const currentBatchIds = new Set(batches.map((b) => b.input_id));
    const hasZero = batchesCategories?.some(
      (batchCategory) =>
        batchCategory.batch_id !== undefined &&
        currentBatchIds.has(batchCategory.batch_id) &&
        (batchCategory.price === '0.00' ||
          parseFloat(batchCategory.price) === 0)
    );

    if (
      hasZero &&
      (basicData.free === false ||
        eventPaymentsMethods[0].payment_method_id !== 0)
    ) {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: 'Existem categorias com o valor zero!',
        text: 'Por favor, verifique os preços definidos para as categorias nos lotes.',
      }).then((result) => {
        if (result.isConfirmed) {
          setProgressNumber(8);
        }
      });
      return;
    }

    try {
      if (statusName === 'Cadastrando') {
        await api.put(`events/organizer/${basicData.event_id}`, {
          status_id: 1,
        });
      }
      Toast.fire({
        icon: 'success',
        iconColor: '#ff6900',
        title: 'Evento adicionado com sucesso!',
      });
      history.push(`${process.env.PUBLIC_URL}/eventos`);
    } catch (error) {
      setLoading(false);
      Swal.fire('Oops...', 'Ocorreu um erro tente novamente!', 'error');
    }
  }, [
    basicData.event_id,
    basicData.free,
    batches,
    batchesCategories,
    eventPaymentsMethods,
    history,
    statusName,
  ]);

  const checkPrice = useCallback(
    (batchesCategoriesData: IBatchCategory[], categoryId, modalityId) => {
      if (batchesCategoriesData) {
        const batchCategoryIndex = batchesCategoriesData.findIndex(
          (batchCategory) => {
            return (
              batchCategory.category_id === categoryId &&
              batchCategory.modality_id === modalityId
            );
          }
        );

        if (batchCategoryIndex >= 0) {
          return parseFloat(
            batchesCategoriesData[batchCategoryIndex].price
          ).toFixed(2);
        }
      }

      return '0.00';
    },
    []
  );

  return (
    <Container>
      <div className="container-fluid">
        <div>
          <div className="row">
            <div className="col-12 px-0">
              <div className="bg-white d-flex justify-content-between align-items-center p-4">
                <h1 className="mb-0">
                  {pageType === 'new' ? 'Novo' : 'Editar'} Evento / {name}
                </h1>
              </div>
            </div>
            <div className="col-12 px-0">
              <div className="bg-white p-3 mt-3">
                <div className="row justify-content-center">
                  <div className="col-xl-10 col-xxl-9">
                    <div className="d-flex justify-content-center align-items-center">
                      {progress.map((index) => (
                        <>
                          <div
                            className={
                              location.pathname.includes('resumo')
                                ? 'pe-none'
                                : ''
                            }
                          >
                            <button
                              type="button"
                              className="bg-transparent border-0 position-relative"
                              disabled={index > progressNumber}
                              onClick={() => setProgressNumber(index)}
                            >
                              <span
                                className={`${
                                  index < progressNumber + 1
                                    ? 'circle-active'
                                    : 'circle'
                                }`}
                              >
                                {index}
                              </span>

                              <span
                                className={`text ${
                                  index < progressNumber + 1
                                    ? 'text-active'
                                    : ''
                                }`}
                              >
                                {textProgress[index - 1].name}
                              </span>
                            </button>
                          </div>
                          {index !== progress.length && (
                            <hr
                              className={`${
                                index < progressNumber + 1 && 'hr-active'
                              } w-11 my-0 mx-2`}
                            />
                          )}
                        </>
                      ))}
                    </div>
                  </div>

                  <div
                    className={`${
                      progressNumber === 3 || progressNumber === 4
                        ? 'col-lg-12 col-xl-11 col-xxl-9'
                        : ''
                    } ${
                      progressNumber === 8 || progressNumber === 10
                        ? 'col-lg-12'
                        : 'col-lg-9'
                    } mt-2`}
                  >
                    <div
                      className={`${
                        progressNumber === 1 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <BasicData
                        ref={basicDataFormRef}
                        sold={someSellout}
                        initialData={basicData}
                        onChangeEventName={handleChangeName}
                        onChangeType={handleChangeType}
                        onChange={handleChangeBasicData}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 2 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <ImageGallery
                        ref={galleryFormRef}
                        initialData={filesInfo}
                        event_id={basicData.event_id as number}
                        onChange={handleChangeGallery}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 3 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Sponsors
                        ref={sponsorsFormRef}
                        initialData={cardsSponsors}
                        event_id={basicData.event_id as number}
                        onChange={handleChangeSponsors}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 4 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Kits
                        ref={kitsFormRef}
                        initialData={{
                          kitId,
                          description: kitDescription,
                          stock_control: kitStockControl,
                          has_size_variation: kitVariationSize,
                          kit_enabled: kitEnabled,
                          kits: cardsKit,
                          sizes: sizesKit,
                        }}
                        onKitErrorChange={setErrorKits}
                        sold={someSellout}
                        event_id={basicData.event_id as number}
                        onChange={handleChangeKits}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 5 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Modalities
                        ref={modalitiesFormRef}
                        sold={someSellout}
                        event_id={basicData.event_id as number}
                        onChange={handleChangeModalities}
                        typeSelected={typeSelected}
                        progressNumber={progressNumber}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 6 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Categories
                        ref={categoriesFormRef}
                        modalities={modalities}
                        sold={someSellout}
                        typeSelected={typeSelected}
                        onChange={handleChangeCategories}
                        event_id={basicData.event_id as number}
                        batchesCategories={batchesCategories}
                        batches={batches}
                        progressNumber={progressNumber}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 7 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Batches
                        ref={batchesFormRef}
                        batches={batches}
                        onChange={handleChangeBatches}
                        basicData={basicData}
                        batchesCategories={batchesCategories}
                        modalities={modalities}
                        progressNumber={progressNumber}
                      />
                    </div>

                    <div
                      className={`${progressNumber === 8 ? 'row' : 'd-none'}`}
                    >
                      <PricesPlaces
                        ref={pricesPlacesFormRef}
                        event_id={basicData.event_id as number}
                        batches={batches}
                        modalities={modalities}
                        onChange={handleChangePricesPlaces}
                        statusName={statusName}
                        batchesCategories={batchesCategories}
                        progressNumber={progressNumber}
                      />
                    </div>

                    <div
                      className={`${
                        progressNumber === 9 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <Financial
                        ref={financeFormRef}
                        basicData={basicData}
                        batches={batches}
                        modalities={modalities}
                        targets={targets}
                        sold={someSellout}
                        eventPaymentsMethods={eventPaymentsMethods}
                        onChange={handleChangeFinancial}
                        statusName={statusName}
                        progressNumber={progressNumber}
                      />
                    </div>

                    <Form
                      ref={formRef}
                      onSubmit={handleSubmit}
                      className={`${progressNumber === 10 ? 'row' : 'd-none'}`}
                    >
                      <div className="col-12">
                        <h2 className="h4 fw-semibold text-center mt-5 mb-4">
                          10 - Resumo e finalizar
                        </h2>
                        <p className="mb-4 text-center">
                          Seu evento esta quase lá! Basta revisar os dados e
                          salvar
                        </p>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h2 className="h4 fw-semibold mb-0">Dados básicos</h2>
                          {statusName === 'Cadastrando' ||
                          statusName === 'Rascunho' ||
                          statusName === 'Em Alteração' ? (
                            <button
                              type="submit"
                              className="mb-0 h6 fw-normal text-white btn-new px-5 py-2"
                            >
                              Salvar
                            </button>
                          ) : (
                            <Link
                              to={`${process.env.PUBLIC_URL}/eventos`}
                              className="text-center mb-0 h6 fw-normal text-white btn-new px-3 py-2"
                            >
                              Voltar aos eventos
                            </Link>
                          )}
                        </div>
                      </div>
                      {Object.keys(basicData).length > 0 && (
                        <div className="col-lg-8 px-3">
                          <div className="row">
                            <div
                              className={`${
                                basicData.hour || basicData.end_hour
                                  ? 'col-lg-4'
                                  : 'col-lg-6'
                              } px-lg-2 mt-3`}
                            >
                              <h3 className="h6 fw-normal">Nome do evento</h3>
                              <Input
                                name="name"
                                type="text"
                                value={name}
                                readOnly
                                className="pe-none input"
                              />
                            </div>
                            <div className="col-lg-2 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Tipo</h3>
                              <Input
                                name="type"
                                type="text"
                                value={typeName}
                                readOnly
                                className="pe-none input"
                              />
                            </div>
                            <div className="col-lg-2 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Data Inicio</h3>
                              <InputDate
                                className="py-1 pe-none"
                                name="date"
                                selected={
                                  basicData.date
                                    ? new Date(basicData.date)
                                    : null
                                }
                                colorSvg="#5D5D5D"
                              />
                            </div>
                            {basicData.hour && (
                              <div className="col-lg-1 px-lg-2 mt-3">
                                <h3 className="h6 fw-normal">H&nbsp;Início</h3>
                                <InputMask
                                  kind="custom"
                                  name="hour"
                                  options={{ mask: '99:99' }}
                                  placeholder="HH:MM"
                                  className="pe-none height-hour px-2 py-1"
                                  value={basicData.hour}
                                />
                              </div>
                            )}
                            <div className="col-lg-2 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Data Fim</h3>
                              <InputDate
                                className="py-1 pe-none"
                                name="end_date"
                                selected={
                                  basicData.end_date
                                    ? new Date(basicData.end_date)
                                    : null
                                }
                                colorSvg="#5D5D5D"
                              />
                            </div>
                            {basicData.end_hour && (
                              <div className="col-lg-1 px-lg-2 mt-3">
                                <h3 className="h6 fw-normal">H&nbsp;Fim</h3>
                                <InputMask
                                  name="end_hour"
                                  kind="custom"
                                  options={{ mask: '99:99' }}
                                  placeholder="HH:MM"
                                  className="pe-none height-hour px-2 py-1"
                                  value={basicData.end_hour}
                                />
                              </div>
                            )}
                            {/* <div className="col-lg-6 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Fim das Vendas</h3>
                              <InputDate
                                className="py-1 pe-none"
                                name="sales_end_date"
                                selected={
                                  basicData.sales_end_date
                                    ? new Date(basicData.sales_end_date)
                                    : null
                                }
                                colorSvg="#5D5D5D"
                              />
                            </div> */}
                            <div className="col-lg-4 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Status</h3>
                              <Input
                                name="status"
                                type="text"
                                value={statusName}
                                readOnly
                                className="pe-none input"
                              />
                            </div>
                            <div className="col-8 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Endereço</h3>
                              <Input
                                value={`${basicData.address}`}
                                name="address_summary"
                                type="text"
                                readOnly
                                className="pe-none input"
                              />
                            </div>

                            <div className="col-12 px-lg-2 mt-3">
                              <iframe
                                src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_MAPS_KEY}&q=${addressMap}&zoom=15`}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="map"
                              />
                            </div>
                            <div className="col-12 px-lg-2 mt-3">
                              <h3 className="h6 fw-normal">Descrição</h3>

                              <div
                                className="rounded textarea-description textarea texts"
                                dangerouslySetInnerHTML={{
                                  __html: basicData.description,
                                }}
                              />
                            </div>
                            {basicData.questions &&
                              basicData.questions.length > 0 && (
                                <div className="pe-none col-12 px-lg-2 mt-3">
                                  <div className="bg-questions p-3">
                                    <h4 className="mb-3">
                                      Perguntas para os atletas
                                    </h4>

                                    <div className="row justify-content-between">
                                      <div className="col-lg-5">
                                        <div className="bg-white p-3">
                                          <h6 className="mb-3">
                                            Adicionar pergunta:
                                          </h6>
                                          <button
                                            type="button"
                                            className="btn-title border-0 bg-transparent d-flex align-items-center mb-2"
                                          >
                                            <FiPlus
                                              size={16}
                                              color="#FF842F"
                                              className="me-2"
                                            />{' '}
                                            Múltipla Escolha
                                          </button>
                                          <button
                                            type="button"
                                            className="btn-title border-0 bg-transparent d-flex align-items-center mb-2"
                                          >
                                            <FiPlus
                                              size={16}
                                              color="#FF842F"
                                              className="me-2"
                                            />{' '}
                                            Escolha Única
                                          </button>
                                          <button
                                            type="button"
                                            className="btn-title border-0 bg-transparent d-flex align-items-center"
                                          >
                                            <FiPlus
                                              size={16}
                                              color="#FF842F"
                                              className="me-2"
                                            />{' '}
                                            Resposta Curta (por escrito)
                                          </button>
                                        </div>
                                      </div>
                                      <div
                                        className="col-lg-6"
                                        id="bg-questions"
                                      >
                                        {basicData.questions.map(
                                          (question, index) => (
                                            <>
                                              {question.question && (
                                                <div
                                                  key={question.id}
                                                  className="grab"
                                                >
                                                  <div className="bg-white border cursor-grab p-3 mb-3">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                      <h6 className="btn-title mb-0">
                                                        {question.type ===
                                                          'free-text' &&
                                                          'Resposta Curta (por escrito)'}
                                                        {question.type ===
                                                          'multiple-choice' &&
                                                          'Múltipla Escolha'}
                                                        {question.type ===
                                                          'unique-choice' &&
                                                          'Escolha Única'}
                                                      </h6>{' '}
                                                      <hr />
                                                    </div>
                                                    <div className="d-flex align-items-center mb-3">
                                                      <span>Ocultar</span>
                                                      <div className="form-check form-switch ms-2">
                                                        <input
                                                          className="form-check-input"
                                                          type="checkbox"
                                                          id={`flexSwitchCheckDefault_${question.id}`}
                                                          checked={
                                                            question.suspended
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                    <h6>Pergunta:</h6>
                                                    <div className="mb-3">
                                                      <Input
                                                        type="text"
                                                        className="input"
                                                        placeholder="Digite aqui"
                                                        name="freeText"
                                                        value={
                                                          question.question
                                                        }
                                                      />
                                                      {question.type ===
                                                        'free-text' && (
                                                        <InputCheckbox
                                                          type="checkbox"
                                                          name={`required_${index}`}
                                                          className="checkbox"
                                                          options={[
                                                            {
                                                              value: 'required',
                                                              label:
                                                                'Resposta obrigatória',
                                                              selected:
                                                                question.isRequired,
                                                            },
                                                          ]}
                                                        />
                                                      )}
                                                    </div>
                                                    {question.alternatives?.map(
                                                      (alternative) => (
                                                        <>
                                                          {alternative.text && (
                                                            <div
                                                              key={
                                                                alternative.id
                                                              }
                                                            >
                                                              <div className="answers d-flex align-items-center justify-content-between rounded-pill mb-2 px-3 py-2">
                                                                {
                                                                  alternative.text
                                                                }
                                                              </div>
                                                            </div>
                                                          )}
                                                        </>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                      <div className="col-lg-4 px-3 pt-3">
                        <div>
                          <button
                            type="button"
                            onClick={() => setBtnPhotoProd('galery')}
                            className={`${
                              btnPhotoProd === 'galery'
                                ? 'btn-photo-prod-active'
                                : 'btn-photo-prod'
                            } bg-transparent h6 fw-normal roboto`}
                          >
                            Galeria de fotos
                          </button>
                          <button
                            type="button"
                            onClick={() => setBtnPhotoProd('products')}
                            className={`${
                              btnPhotoProd === 'products'
                                ? 'btn-photo-prod-active'
                                : 'btn-photo-prod'
                            } bg-transparent h6 fw-normal roboto ms-3`}
                          >
                            Kit
                          </button>
                          <button
                            type="button"
                            onClick={() => setBtnPhotoProd('sponsors')}
                            className={`${
                              btnPhotoProd === 'sponsors'
                                ? 'btn-photo-prod-active'
                                : 'btn-photo-prod'
                            } bg-transparent h6 fw-normal roboto ms-3`}
                          >
                            Patrocinadores
                          </button>
                        </div>

                        {btnPhotoProd === 'galery' && (
                          <div>
                            {filesInfo.map((file, index) => (
                              <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                className="d-flex justify-content-between arquives p-3 mt-3"
                              >
                                <div className="d-flex align-items-center">
                                  <img src={file.url} alt={file.name} />
                                  <p className="ms-3 mb-0">{file.name}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {btnPhotoProd === 'products' && (
                          <>
                            <div className="d-flex">
                              <div className="d-flex overflow-auto pb-2 position-relative">
                                <div className="w-card-summary px-2 mt-3">
                                  <div className="d-flex">
                                    {cardsKit.map((kit) => (
                                      <div className="cards-sponsor pb-3 mx-2">
                                        <div className="card bg-white p-4">
                                          <div className="d-flex justify-content-end">
                                            <button
                                              type="button"
                                              className="opacity-25 border-0 rounded-circle bg-gray me-2 position-relative"
                                            >
                                              <BsChatRightText
                                                size={16}
                                                color="#fff"
                                              />
                                            </button>
                                            <button
                                              type="button"
                                              className="opacity-25 border-0 rounded-circle bg-gray me-2"
                                            >
                                              <KrEdit size={16} color="#fff" />
                                            </button>
                                            <button
                                              type="button"
                                              className="opacity-25 border-0 rounded-circle bg-gray"
                                            >
                                              <KrTrash size={16} color="#fff" />
                                            </button>
                                          </div>

                                          <img
                                            src={kit.file.url}
                                            alt="Logo patrocinador"
                                            className="w-100 my-3"
                                          />

                                          <span>
                                            <a
                                              className={`${
                                                kit.link
                                                  ? ''
                                                  : 'pe-none opacity-25'
                                              } link-ext d-inline-flex align-items-center`}
                                              href={kit.link}
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              Link externo{' '}
                                              <span className="ms-2">
                                                <IoIosShareAlt
                                                  size={16}
                                                  color="#fff"
                                                />
                                              </span>
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>{' '}
                            {kitVariationSize && (
                              <>
                                <div>
                                  <p className="mb-2 text-black">Unissex</p>
                                  <div className="row">
                                    {sizesKit.map((size) => (
                                      <>
                                        {!size.size.includes('_BABY') &&
                                          Number.isNaN(
                                            parseInt(size.size, 10)
                                          ) && (
                                            <div className="col-3 mb-3">
                                              <div className="d-felx variation-row">
                                                <div>
                                                  <p className="mb-1 size text-center me-3">
                                                    {size.size}
                                                  </p>
                                                </div>
                                                {kitStockControl && (
                                                  <div className="d-flex align-items-center">
                                                    <Input
                                                      name="qtyPp"
                                                      type="number"
                                                      min={0}
                                                      disabled
                                                      className="input me-2"
                                                      value={size.quantity}
                                                    />{' '}
                                                    <p
                                                      className={` mb-0 pt-1 small fst-italic text-center`}
                                                    >
                                                      {size.qtdSold ?? 0}
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                              <div className="form-check form-switch">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id="flexSwitchCheckDefault"
                                                  checked={size.active}
                                                />
                                              </div>
                                            </div>
                                          )}
                                      </>
                                    ))}
                                  </div>
                                </div>
                                <hr className="mx-2 mt-0" />
                                <div>
                                  <p className="mb-2 text-black">Babylook</p>
                                  <div className="row">
                                    {sizesKit.map((size) => (
                                      <>
                                        {size.size.includes('_BABY') && (
                                          <div className="col-3 mb-3">
                                            <div className="d-felx variation-row">
                                              <div>
                                                <p className="mb-1 size text-center me-3">
                                                  {size.size.replace(
                                                    '_BABY',
                                                    ''
                                                  )}
                                                </p>
                                              </div>
                                              {kitStockControl && (
                                                <div className="d-flex align-items-center">
                                                  <Input
                                                    name="qtyPp"
                                                    type="number"
                                                    min={0}
                                                    disabled
                                                    className="input me-2"
                                                    value={size.quantity}
                                                  />{' '}
                                                  <p
                                                    className={` mb-0 pt-1 small fst-italic text-center`}
                                                  >
                                                    {size.qtdSold ?? 0}
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexSwitchCheckDefault"
                                                checked={size.active}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ))}
                                  </div>
                                </div>
                                <hr className="mx-2 mt-0" />
                                <div>
                                  <p className="mb-2 text-black">Infantil</p>
                                  <div className="row">
                                    {sizesKit.map((size) => (
                                      <>
                                        {!Number.isNaN(
                                          parseInt(size.size, 10)
                                        ) && (
                                          <div className="col-3 mb-3">
                                            <div className="d-felx variation-row">
                                              <div>
                                                <p className="mb-1 size text-center me-3">
                                                  {size.size}
                                                </p>
                                              </div>
                                              {kitStockControl && (
                                                <div className="d-flex align-items-center">
                                                  <Input
                                                    name="qty2Child"
                                                    type="number"
                                                    min={0}
                                                    disabled
                                                    className="input me-2"
                                                    value={size.quantity}
                                                  />{' '}
                                                  <p
                                                    className={` mb-0 pt-1 small fst-italic text-center`}
                                                  >
                                                    {size.qtdSold ?? 0}
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexSwitchCheckDefault"
                                                checked={size.active}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ))}
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {btnPhotoProd === 'sponsors' && (
                          <div className="d-flex overflow-auto pb-2">
                            <div className="w-card-summary px-2 mt-3">
                              <div className="d-flex">
                                {cardsSponsors.map((sponsor) => (
                                  <div className="cards-sponsor pb-3 mx-2">
                                    <div className="card bg-white p-4">
                                      <div className="d-flex justify-content-end">
                                        <button
                                          type="button"
                                          className="opacity-25 border-0 rounded-circle bg-gray me-2 position-relative"
                                        >
                                          <BsChatRightText
                                            size={16}
                                            color="#fff"
                                          />
                                        </button>
                                        <button
                                          type="button"
                                          className="opacity-25 border-0 rounded-circle bg-gray me-2"
                                        >
                                          <KrEdit size={16} color="#fff" />
                                        </button>
                                        <button
                                          type="button"
                                          className="opacity-25 border-0 rounded-circle bg-gray"
                                        >
                                          <KrTrash size={16} color="#fff" />
                                        </button>
                                      </div>

                                      <img
                                        src={sponsor.file.url}
                                        alt="Logo patrocinador"
                                        className="w-100 my-3"
                                      />

                                      <p>{sponsor.name}</p>
                                      <span>
                                        <a
                                          className="link-ext d-inline-flex align-items-center"
                                          href={sponsor.link}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          Link externo{' '}
                                          <span className="ms-2">
                                            <IoIosShareAlt
                                              size={16}
                                              color="#fff"
                                            />
                                          </span>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-12">
                        <h3 className="poppins py-4">Preços e vagas</h3>
                      </div>
                      {batches.map((batch, index) => (
                        <div key={batch.input_id} className="col-lg-6">
                          <div className="bg-category p-3 mb-3">
                            <h5 className="roboto h5 fw-semibold">
                              Lote {index + 1}
                            </h5>
                            <p className="mb-0">
                              Vagas:{' '}
                              {batch.qtdPlaces?.toString() === '0' ||
                              !batch.qtdPlaces
                                ? 'Ilimitadas'
                                : batch.qtdPlaces}{' '}
                              | Validade:
                              {format(batch.expiration, 'dd/MM/yyyy')} | Qtd.
                              vendida: {batch.qtdSold ?? 0}
                            </p>
                          </div>
                          {modalities.map((modality) => (
                            <Fragment key={modality.id}>
                              {modality.categories?.map((category) => (
                                <div
                                  key={category.id}
                                  className="bd-lots all-lots mb-3 p-3 d-flex justify-content-between align-items-center"
                                >
                                  <div className="w-32">
                                    <h3 className="h6 mb-1 fw-semibold roboto align-items-center">
                                      {modality.name}: {category.name}
                                      <br />
                                      <small>
                                        Qtd. vendida:{' '}
                                        {batch.batchesCategories?.find(
                                          (batchCategory) =>
                                            batchCategory.category_id ===
                                              category.id &&
                                            batchCategory.modality_id ===
                                              modality.id
                                        )?.quantity_sold || 0}
                                      </small>
                                    </h3>
                                    <p className="mb-0 cimf">
                                      <span
                                        className={`${
                                          category.has_kit
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        K
                                      </span>
                                      <span> | </span>
                                      <span
                                        className={`${
                                          category.child
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        C
                                      </span>
                                      <span> | </span>
                                      <span
                                        className={`${
                                          category.elderly
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        I
                                      </span>
                                      <span> | </span>
                                      <span
                                        className={`${
                                          category.male
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        M
                                      </span>
                                      <span> | </span>
                                      <span
                                        className={`${
                                          category.female
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        F
                                      </span>
                                      <span> | </span>
                                      <span
                                        className={`${
                                          category.qty_min &&
                                          category.qty_min > 0
                                            ? 'black-text fw-semibold'
                                            : 'gray-text'
                                        }`}
                                      >
                                        Min: {category.qty_min}
                                      </span>
                                    </p>
                                    <p className="ps-4 small-80 mb-0">
                                      <span className="black-text fw-semibold">
                                        {category.min_age}
                                      </span>{' '}
                                      -{' '}
                                      <span className="black-text fw-semibold">
                                        {category.max_age}
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                                      Qtd. de vagas
                                    </span>
                                    <Input
                                      type="number"
                                      name="qtd-places"
                                      placeholder="0"
                                      value={
                                        batch.batchesCategories
                                          ? batch.batchesCategories[
                                              batch.batchesCategories?.findIndex(
                                                (batchCategory) =>
                                                  batchCategory.category_id ===
                                                    category.id &&
                                                  batchCategory.modality_id ===
                                                    modality.id
                                              )
                                            ]?.quantity || 0
                                          : 0
                                      }
                                      readOnly
                                      className="pe-none w-75 mx-auto input"
                                    />
                                  </div>

                                  <div>
                                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                                      Preços
                                    </span>
                                    <InputMask
                                      kind="money"
                                      name="price"
                                      placeholder="R$ 0,00"
                                      value={
                                        batch.batchesCategories
                                          ? checkPrice(
                                              batch.batchesCategories,
                                              category.id,
                                              modality.id
                                            )
                                          : '0'
                                      }
                                      className="pe-none w-75 mx-auto input"
                                    />
                                  </div>
                                  <div className="w-18">
                                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block text-center">
                                      Suspender
                                    </span>
                                    <div className="form-check form-switch d-flex justify-content-center">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexSwitchCheckDefault"
                                        checked={
                                          typeof batch.batchesCategories?.find(
                                            (batchCategory) =>
                                              batchCategory.category_id ===
                                                category.id &&
                                              batchCategory.modality_id ===
                                                modality.id
                                          )?.on === 'undefined'
                                            ? false
                                            : !batch.batchesCategories?.find(
                                                (batchCategory) =>
                                                  batchCategory.category_id ===
                                                    category.id &&
                                                  batchCategory.modality_id ===
                                                    modality.id
                                              )?.on
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Fragment>
                          ))}
                        </div>
                      ))}

                      <div className="col-12">
                        <h3 className="poppins py-4">Financeiro</h3>
                      </div>
                      <div className="col-lg-9">
                        <div className="row">
                          <div className="col-lg-7 px-lg-2">
                            <h3 className="d-flex align-items-center justify-content-between h6 fw-normal position-relative">
                              Inscrições serem obrigatoriamente preenchidas
                              antes do pagamento
                            </h3>
                            <InputCheckbox
                              type="radio"
                              name="tickets_before_payment"
                              className="pe-none check-payments mt-2 justify-content-start"
                              options={[
                                {
                                  label: 'Sim',
                                  value: 'sim',
                                  selected: beforePayment === 1,
                                },
                                {
                                  label: 'Não',
                                  value: 'nao',
                                  selected: beforePayment === 0,
                                },
                                {
                                  label: 'Não necessita preenchimento',
                                  value: 'nao_necessita',
                                  selected: beforePayment === 2,
                                },
                              ]}
                            />
                          </div>
                          <div className="col-lg-5 px-lg-2">
                            <h3 className="d-flex h6 fw-normal position-relative">
                              Evento com inscrição única por atleta?
                            </h3>
                            <InputCheckbox
                              type="radio"
                              name="unique_ticket_per_athlete"
                              className="check-payments mt-2 justify-content-start"
                              options={[
                                {
                                  label: 'Sim',
                                  value: 'sim',
                                  selected: basicData.unique_ticket,
                                },
                                {
                                  label: 'Não',
                                  value: 'nao',
                                  selected: !basicData.unique_ticket,
                                },
                              ]}
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">Contrato</h3>
                            <Select
                              name="contract"
                              className="pe-none input"
                              options={contractsOptions}
                              placeholder="Selecione"
                              disabled={contractsOptions.length === 1}
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">Taxa de serviço</h3>
                            <Input
                              readOnly
                              value={`${
                                contractSelected.service_type === 'Valor'
                                  ? 'R$'
                                  : ''
                              }${parseFloat(contractSelected?.service || '0')
                                .toFixed(2)
                                .replace('.', ',')}${
                                contractSelected.service_type === 'Porcentagem'
                                  ? '%'
                                  : ''
                              }`}
                              name="serviceTax"
                              className="input"
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">
                              Taxa de processamento
                            </h3>
                            <Input
                              readOnly
                              value={`${
                                contractSelected.tax_type === 'Valor'
                                  ? 'R$'
                                  : ''
                              }${parseFloat(contractSelected?.tax || '0')
                                .toFixed(2)
                                .replace('.', ',')}${
                                contractSelected.tax_type === 'Porcentagem'
                                  ? '%'
                                  : ''
                              }`}
                              name="processingTax"
                              className="input"
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">Meta de inscrições</h3>
                            <Input
                              type="number"
                              min={0}
                              name="targetRegistration"
                              className="input"
                              value={targets.registration}
                              readOnly
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">Meta de receita</h3>
                            <Input
                              readOnly
                              value={formatPrice(targets.revenue)}
                              name="targetRevenue"
                              className="input"
                            />
                          </div>
                          <div className="col-lg-4 mt-3 px-lg-2">
                            <h3 className="h6 fw-normal">
                              Meta de Ticket médio
                            </h3>
                            <Input
                              readOnly
                              value={formatPrice(targets.avarageTicket)}
                              name="targetAvarageTicket"
                              className="input"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 px-lg-2">
                        <h3 className="h6 fw-normal mb-0">
                          Formas de pagamentos
                        </h3>
                        <InputCheckbox
                          type="checkbox"
                          name="pix"
                          className="check-payments mt-2 flex-column justify-content-start pe-none"
                          options={paymentMethodsOptions}
                        />
                        {creditPayment && (
                          <>
                            <h3 className="h6 fw-normal mb-1">
                              Máximo de parcelas
                            </h3>
                            <Input
                              name="maxInstallments"
                              className="input"
                              value={maxInstallments}
                              readOnly
                            />
                          </>
                        )}
                      </div>
                    </Form>

                    <div className="row">
                      <div className="col-12 d-flex justify-content-center mt-4">
                        {progressNumber !== 1 &&
                          !location.pathname.includes('resumo') && (
                            <button
                              type="button"
                              onClick={() =>
                                setProgressNumber(progressNumber - 1)
                              }
                              className="mb-0 me-4 h6 fw-normal text-white btn-new px-5 py-2 mt-2"
                            >
                              Anterior
                            </button>
                          )}
                        {progressNumber !== 10 && (
                          <button
                            type="button"
                            disabled={errorKits}
                            onClick={() => handleClickNext(progressNumber)}
                            className={`${
                              errorKits ? 'not-allowed opacity-50' : ''
                            } mb-0 me-4 h6 fw-normal text-white btn-new px-5 py-2 mt-2`}
                          >
                            Salvar e avançar
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading active={loading} text="Carregando..." />
    </Container>
  );
};

export default ManageEvent;
